import { registerLocaleData } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import localePt from "@angular/common/locales/pt";
import { inject, LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { environment } from "@env/environment";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { provideNgIconLoader } from "@ng-icons/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { provideHotToastConfig } from "@ngxpert/hot-toast";
import { NgxLoadingModule } from "ngx-loading-reloaded";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { Interceptor } from "./auth/services/interceptors/interceptor";
import { CoreModule } from "./core/core.module";
import { SkeletonLoadingComponent } from "./shared/components/skeleton-loading/skeleton-loading.component";
import { SharedModule } from "./shared/shared.module";

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    SharedModule,
    CoreModule,
    NgbModule,
    NgxLoadingModule.forRoot({}),
    SkeletonLoadingComponent,
    RouterModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    { provide: LOCALE_ID, useValue: "pt" },
    provideHotToastConfig(),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: "text" });
    }),
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
